/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'REFERENCE_TO_FOLLOWING_ALL_LOCAL_LAWS_FOR_RECRUITMENT_IN_BOTH_T',
              'RECRUITMENT_FEES_AND_EXPENSES',
              'EMPLOYMENT_CONTRACTS',
              'DEPOSITS',
              'BANK_ACCOUNTS',
              'HANDLING_OF_GOVERNMENT_ISSUED_IDENTIFICATION_DOCUMENTS',
              'ACCOMMODATIONS',
              'ARRIVAL_ORIENTATION',
              'FREEDOM_OF_MOVEMENT',
              'NON_DISCRIMINATION_IN_EMPLOYMENT',
              'HARASSMENT_AND_ABUSE_IN_EMPLOYMENT',
              'DISCIPLINE_IN_EMPLOYMENT',
              'REPATRIATION_END_OF_EMPLOYMENT',
              'EARLY_TERMINATION_OF_CONTRACT_BY_MIGRANT_WORKER',
              'INVOLUNTARY_TERMINATION_OF_CONTRACT_BY_EMPLOYER',
              'REQUIREMENTS_FOR_LABOR_AGENTS_BROKERS',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_11: valueSchema,
  },
}
